export default "__VITE_ASSET__882c3cde__"